// extracted by mini-css-extract-plugin
export default {"root":"MinitableContent_root__pzNCp","rootContent":"MinitableContent_rootContent__iA6Ss"};